export default "__VITE_ASSET__CYjQdTx6__"